import { PaymentPartnerType } from '../../codegen/transactions';
import { PAYMENT_PARTNER_TO_TRANSLATION_KEY } from '../../i18n/enumMappings';
import { PaymentPartnerIcon } from '../icons/PaymentPartnerIcon';

type PaymentPartnerRepresentationProps = {
  paymentPartner: PaymentPartnerType;
};

export const PaymentPartnerRepresentation = ({
  paymentPartner,
}: PaymentPartnerRepresentationProps) => {
  return (
    <div className="display-flex gap-5 align-items-center">
      <PaymentPartnerIcon
        paymentPartner={paymentPartner}
        className="height-20 margin-bottom-0"
      />
      <span className="ellipsis-1">
        {PAYMENT_PARTNER_TO_TRANSLATION_KEY[paymentPartner]}
      </span>
    </div>
  );
};
